import React, { useEffect, useState } from "react";
import { api } from "../../lib/auth";

export default function Hospitals() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/portal/hospitals").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-[#0B132B]">Hospital Network</h1>
        <p className="text-[#4B5563] mt-2">Connected to leading cancer centers worldwide. Find a partner near you.</p>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F8F9FB] text-left text-[11px] uppercase tracking-wider text-[#4B5563]">
            <tr>
              <th className="px-6 py-4">Hospital</th>
              <th className="px-6 py-4">Location</th>
              <th className="px-6 py-4">Patients Supported</th>
              <th className="px-6 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((h) => (
              <tr key={h.id} className="border-t border-gray-100">
                <td className="px-6 py-4 font-semibold text-[#0B132B]">{h.name}</td>
                <td className="px-6 py-4 text-[#4B5563]">{h.city}, {h.country}</td>
                <td className="px-6 py-4 text-[#4B5563]">{h.patients_supported?.toLocaleString()}</td>
                <td className="px-6 py-4">
                  <span className="text-[10px] font-bold bg-[#2D9B4E]/10 text-[#23803F] px-2 py-1 rounded-full">
                    CONNECTED
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
